import { donacionExterna } from '../../api/donar/donacionExterna';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

const donacionExternaModule = createApiModule({
  name: 'donacionExterna',
  apiMethod: donacionExterna,
  initialData: null,
  parse: (donacion) => donacion,
  onSuccess: () => {},
  onError: () => ({
    message: t(
      'StoreDonacionExternaDonacionExternaModuleErrorCreandoLaDonacion',
    ),
  }),
  onValidationError: () => ({
    message: t(
      'StoreDonacionExternaDonacionExternaModuleErrorCreandoLaDonacion',
    ),
  }),
});

export const {
  start: createDonacionExterna,
  success: createDonacionExternaOk,
  error: createDonacionExternaKo,
  reset: clearDonacionExterna,
} = donacionExternaModule.slice.actions;

export default donacionExternaModule;
